// extracted by mini-css-extract-plugin
export default {"LiveText":"LiveText_LiveText__R2P4q","LiveText__typist":"LiveText_LiveText__typist__YMZob"};